<ng-container *transloco="let translated">
  <div [formGroup]="formGroup">
    @for (typeUser of ACCOUNT_TYPES; track typeUser.id) {
      <label [for]="typeUser.id" class="btn btn-outline-default mr-2">
        <div class="custom-control custom-radio">
          <input
            type="radio"
            formControlName="typeAccount"
            [value]="typeUser.id"
            class="custom-control-input my-custom-control-input"
            name="typeAccount"
            [id]="typeUser.id"
          />
          <label
            [for]="typeUser.id"
            class="custom-control-label my-custom-control-label cursor-pointer"
            >{{ translated(typeUser.displayText) }}</label
          >
        </div>
      </label>
    }
  </div>
</ng-container>
